module.exports = __webpack_public_path__ + "img/empty-client.b2cf8e94.png";